import { render } from "./WalletAdjustModal.vue?vue&type=template&id=5ced2ddc"
import script from "./WalletAdjustModal.vue?vue&type=script&lang=js"
export * from "./WalletAdjustModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__